import { Button, useDataProvider, useNotify } from "react-admin";

interface IRegeneratePdfButton {
  accountingDocumentNumber: string;
}

const RegeneratePdfButton = ({
  accountingDocumentNumber,
}: IRegeneratePdfButton) => {
  const provider = useDataProvider();
  const notify = useNotify();
  var docType = accountingDocumentNumber.substring(0, 2);

  const regeneratePdfUrlInvoice = () => {
    provider
      .customUpdate(
        `accounting/invoices/${accountingDocumentNumber}/generatePdf`,
        {}
      )
      .then(({ data }: any) => {
        notify("Successfully Generate PDF.");
      })
      .catch(() => {
        notify("Error Generate PDF.", "warning");
      });
  };

  const regeneratePdfUrlCreditNote = () => {
    provider
      .customUpdate(
        `accounting/creditNotes/${accountingDocumentNumber}/generatePdf`,
        {}
      )
      .then(({ data }: any) => {
        notify("Successfully Generate PDF.");
      })
      .catch(() => {
        notify("Error Generate PDF.", "warning");
      });
  };

  return (
    <>
      {(docType === "IN" || docType === "CN") && (
        <Button
          onClick={
            docType === "IN"
              ? regeneratePdfUrlInvoice
              : regeneratePdfUrlCreditNote
          }
          label="Regenerate PDF"
        />
      )}
    </>
  );
};

export default RegeneratePdfButton;
